import { useState } from '@wordpress/element';
import { Icon } from './Icons';
import { trackEvent } from '../utils/analytics';
import { useGiveaway } from '../features/giveaways/GiveawayProvider';
import { requestSlotReward } from '../features/giveaways/giveawayApi';

export default function ShareButton({
    track,
    url,
    className = '',
    label = 'Share',
    showLabel = false,
    location = 'unknown',
}) {
    const [copied, setCopied] = useState(false);

    const baseShareUrl = url || track?.url || window.location.href;

    const finalShareUrl = (() => {
        const shareUrlObject = new URL(baseShareUrl, window.location.origin);

        shareUrlObject.searchParams.set('utm_source', 'decropoverlarder');
        shareUrlObject.searchParams.set(
            'utm_medium',
            navigator.share ? 'native' : 'clipboard'
        );
        shareUrlObject.searchParams.set('utm_campaign', 'track_share');
        shareUrlObject.searchParams.set('utm_content', location);

        return shareUrlObject.toString();
    })();
    const title = track?.title || 'De CropOver Larder';
    const artist = track?.artist || 'Unknown Artist';
    const text = track?.title ? `${title} by ${artist}` : title;

    const { showRewardToken } = useGiveaway();

    async function maybeRewardShare() {
        try {
            const reward = await requestSlotReward('share_track', 'share_track');

            if (reward?.alreadyCollected) {
                return;
            }

            if (!reward?.success || !reward?.token) {
                return;
            }

            showRewardToken(reward.token);
        } catch (error) {
            // ignore
        }
    }

    async function handleShare(event) {
        event.preventDefault();
        event.stopPropagation();

        const shareMethod = navigator.share ? 'native' : 'clipboard';

        trackEvent('track_share_attempt', {
            track_id: track?.id || 'unknown',
            track_title: title,
            artist,
            share_location: location,
            share_method: shareMethod,
        });

        try {
            if (navigator.share) {
                await navigator.share({
                    title,
                    text,
                    url: finalShareUrl,
                });

                trackEvent('track_share', {
                    track_id: track?.id || 'unknown',
                    track_title: title,
                    artist,
                    share_location: location,
                    share_method: 'native',
                });

                await maybeRewardShare();

                return;
            }

            await navigator.clipboard?.writeText(finalShareUrl);
            setCopied(true);

            trackEvent('track_share', {
                track_id: track?.id || 'unknown',
                track_title: title,
                artist,
                share_location: location,
                share_method: 'clipboard',
            });

            await maybeRewardShare();

            window.setTimeout(() => {
                setCopied(false);
            }, 1600);
        } catch (error) {
            trackEvent('track_share_cancelled', {
                track_id: track?.id || 'unknown',
                track_title: title,
                artist,
                share_location: location,
                share_method: shareMethod,
            });
        }
    }

    return (
        <button
            type="button"
            className={`bjnt-share-button ${className}`}
            onClick={handleShare}
            aria-label={`Share ${title}`}
            title={copied ? 'Link copied' : label}
        >
            <Icon name="share" />

            {showLabel && (
                <span>{copied ? 'Copied' : label}</span>
            )}
        </button>
    );
}